import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c6d5a92&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\code\\Dataleading3.0\\dataleading\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c6d5a92"]])

export default __exports__